import * as STD from '@emersya/mpa-std-lib';

import { NS as StandingPartitionsHeadsNS } from '../StandingPartitionsHeads/StandingPartitionsHeads';
import { NS as StorageNS }                 from './StandingStorage';
import ViewerComponent                     from '../../../viewer/Viewer/Viewer';

export default function computeMatrixLightning(this : StorageNS.Component) : ViewerComponent.TMatrix {

	const wdh = this.getWDH();
	const x = wdh.width;
	const y = wdh.height;
	const z = wdh.depth;
	void y;
	const decalage = 0;
	const product = app.currentProduct;
	if (!product) {
		throw STD.errors.user('No current product available!');
	}
	const layoutPart = product.getPart([ 'layout' ]);
	if (!layoutPart) {
		throw STD.errors.user('No part layout available');
	}
	const layoutCurrentOption = layoutPart.currentOption;
	if (!layoutCurrentOption) {
		throw STD.errors.user('No current option in layout part');
	}
	const layoutId = layoutCurrentOption.id;
	if (product.id === 'confort') {
		const surface = x * z;
		if (surface >= 25) {
			if (layoutId === 'shape-no-wall') {
				return (app.viewer.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
			} else if (layoutId === 'shape-back-left') {
				const storage = app.component_configuration.productsComponents.find(x => x.type ===
					'storage' &&
					x.SKU === 'storage3x1CornerLeft');
				if (!storage) {
					throw STD.errors.user('No current storage found');
				}
				const boundingBoxStorage = storage.boundingBox;
				if (!boundingBoxStorage) {
					throw STD.errors.user('Missing bounding box for storage ');
				}
				// return (app.viewer.mtx([ -x / 2 + 1.5, 0, -z / 2 + boundingBoxStorage.width + decalage ], [ 1, 1, 1 ], 180));
				if(x < 4){
					return (app.viewer.mtx([ -decalage, 0, 1 ], [ 1, 1, 1 ], 270));
				}else{
					return (app.viewer.mtx([ -decalage, 0, 1.5 ], [ 1, 1, 1 ], 270));
				}
			} else if (layoutId === 'shape-back') {
				const storage = app.component_configuration.productsComponents.find(x => x.type ===
					'storage' &&
					x.SKU ===
					'storage3x1Side');
				if (!storage) {
					throw STD.errors.user('No current storage found');
				}
				const boundingBoxStorage = storage.boundingBox;
				if (!boundingBoxStorage) {
					throw STD.errors.user('Missing bounding box for storage ');
				}
				// return (app.viewer.mtx([ -x / 2 + 1.5, 0, -z / 2 + boundingBoxStorage.width + decalage ], [ 1, 1, 1 ], 180));
				if(x < 4){
					return (app.viewer.mtx([ -decalage, 0, 1 ], [ 1, 1, 1 ], 270));
				}else{
					return (app.viewer.mtx([ -decalage, 0, 1.5 ], [ 1, 1, 1 ], 270));
				}
			} else if (layoutId === 'shape-back-right') {
				const storage = app.component_configuration.productsComponents.find(x => x.type ===
					'storage' &&
					x.SKU === 'storage3x1CornerRight');
				if (!storage) {
					throw STD.errors.user('No current storage found');
				}
				const boundingBoxStorage = storage.boundingBox;
				if (!boundingBoxStorage) {
					throw STD.errors.user('Missing bounding box for storage ');
				}
				// return (app.viewer.mtx([ x / 2 - boundingBoxStorage.width - decalage, 0, -z / 2 + 1.5 ], [ 1, 1, 1 ], 90));
				if(z < 4){
					return (app.viewer.mtx([ -decalage, 0, 1 ], [ 1, 1, 1 ], 270));
				}else{
					return (app.viewer.mtx([ -decalage, 0, 1.5 ], [ 1, 1, 1 ], 270));
				}
			} else if (layoutId === 'shape-left-back-right') {
				const storage = app.component_configuration.productsComponents.find(x => x.type ===
					'storage' &&
					x.SKU === 'storage3x1CornerRight');
				if (!storage) {
					throw STD.errors.user('No current storage found');
				}
				const boundingBoxStorage = storage.boundingBox;
				if (!boundingBoxStorage) {
					throw STD.errors.user('Missing bounding box for storage ');
				}
				// return (app.viewer.mtx([ -x / 2 + 1.5, 0, -z / 2 + boundingBoxStorage.width + decalage ], [ 1, 1, 1 ], 180));
				if(x < 4){
					return (app.viewer.mtx([ -decalage, 0, 1 ], [ 1, 1, 1 ], 270));
				}else{
					return (app.viewer.mtx([ -decalage, 0, 1.5 ], [ 1, 1, 1 ], 270));
				}
			} else {
				throw STD.errors.user('Unknown layoutId');
			}
		} else if (surface >= 18) {
			if (layoutId === 'shape-no-wall') {
				return (app.viewer.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
			} else if (layoutId === 'shape-back-left') {
				const storage = app.component_configuration.productsComponents.find(x => x.type ===
					'storage' &&
					x.SKU === 'storage2x1CornerLeft');
				if (!storage) {
					throw STD.errors.user('No current storage found');
				}
				const boundingBoxStorage = storage.boundingBox;
				if (!boundingBoxStorage) {
					throw STD.errors.user('Missing bounding box for storage ');
				}
				return (app.viewer.mtx([ -decalage, 0, 1 ], [ 1, 1, 1 ], 270));
			} else if (layoutId === 'shape-back') {
				const storage = app.component_configuration.productsComponents.find(x => x.type ===
					'storage' &&
					x.SKU === 'storage2x1Side');
				if (!storage) {
					throw STD.errors.user('No current storage found');
				}
				const boundingBoxStorage = storage.boundingBox;
				if (!boundingBoxStorage) {
					throw STD.errors.user('Missing bounding box for storage ');
				}
				// return (app.viewer.mtx([ -x / 2 + 1, 0, -z / 2 + boundingBoxStorage.width + decalage ], [ 1, 1, 1 ], 180));
				return (app.viewer.mtx([ -decalage, 0, 1 ], [ 1, 1, 1 ], 270));
			} else if (layoutId === 'shape-back-right') {
				const storage = app.component_configuration.productsComponents.find(x => x.type ===
					'storage' &&
					x.SKU ===
					'storage2x1CornerRight');
				if (!storage) {
					throw STD.errors.user('No current storage found');
				}
				const boundingBoxStorage = storage.boundingBox;
				if (!boundingBoxStorage) {
					throw STD.errors.user('Missing bounding box for storage ');
				}
				return (app.viewer.mtx([ -decalage, 0, 1 ], [ 1, 1, 1 ], 270));
				// return (app.viewer.mtx([ x / 2 - boundingBoxStorage.width - decalage, 0, -z / 2 + 1 ], [ 1, 1, 1 ], 90));
			} else if (layoutId === 'shape-left-back-right') {
				const storage = app.component_configuration.productsComponents.find(x => x.type ===
					'storage' &&
					x.SKU ===
					'storage2x1CornerRight');
				if (!storage) {
					throw STD.errors.user('No current storage found');
				}
				const boundingBoxStorage = storage.boundingBox;
				if (!boundingBoxStorage) {
					throw STD.errors.user('Missing bounding box for storage ');
				}
				// return (app.viewer.mtx([ -x / 2 + 1, 0, -z / 2 + boundingBoxStorage.width + decalage ], [ 1, 1, 1 ], 180));
				return (app.viewer.mtx([ -decalage, 0, 1 ], [ 1, 1, 1 ], 270));
			} else {
				throw STD.errors.user('Unknown layoutId');
			}
		} else {
			return (app.viewer.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
		}
	} else if (product.id === 'siae') {
		const surface = x * z;
		const partitionsHeads = app.modules.used.find(x => x.id === 'standing-partitionsHeads');
		if (!partitionsHeads) {
			throw STD.errors.user('Partitions Heads not instanciate before storage');
		}
		const partitionHeadsComponent = <StandingPartitionsHeadsNS.Component> partitionsHeads.component;
		if (!partitionHeadsComponent) {
			throw STD.errors.user('Partitions Heads doesnt have component in storage');
		}
		const boundingBoxPartitionsHead = partitionHeadsComponent.isPartitionsHeads ?
			partitionHeadsComponent.partitionsWidth :
			0;
		if (!boundingBoxPartitionsHead && boundingBoxPartitionsHead !== 0) {
			throw STD.errors.user('Missing bounding box for partitionsHeads in storage');
		}
		if (surface >= 31) {
			if (layoutId === 'shape-no-wall') {
				return (app.viewer.mtx([ 0, 0, 0 ], [ 0, 0, 0 ], 0));
			} else if (layoutId === 'shape-back-left') {
				const storage = app.component_configuration.productsComponents.find(x => x.type ===
					'storage' &&
					x.SKU === 'storage3x1CornerRight');
				if (!storage) {
					throw STD.errors.user('No current storage found');
				}
				const boundingBoxStorage = storage.boundingBox;
				if (!boundingBoxStorage) {
					throw STD.errors.user('Missing bounding box for storage ');
				}
				return (app.viewer.mtx([ boundingBoxStorage.width + decalage, 0, 1.5 ], [ 1, 1, 1 ], 90));
			} else if (layoutId === 'shape-back') {
				const storage = app.component_configuration.productsComponents.find(x => x.type ===
					'storage' &&
					x.SKU ===
					'storage3x1Classic');
				if (!storage) {
					throw STD.errors.user('No current storage found');
				}
				const boundingBoxStorage = storage.boundingBox;
				if (!boundingBoxStorage) {
					throw STD.errors.user('Missing bounding box for storage ');
				}
				return (app.viewer.mtx([
					decalage + boundingBoxStorage.width,
					0,
					1.5
				], [ 1, 1, 1 ], 90));
			} else if (layoutId === 'shape-back-right') {
				const storage = app.component_configuration.productsComponents.find(x => x.type ===
					'storage' &&
					x.SKU ===
					'storage3x1CornerLeft');
				if (!storage) {
					throw STD.errors.user('No current storage found');
				}
				const boundingBoxStorage = storage.boundingBox;
				if (!boundingBoxStorage) {
					throw STD.errors.user('Missing bounding box for storage ');
				}
				return (app.viewer.mtx([ -decalage, 0, 1.5 ], [ 1, 1, 1 ], 270));
			} else if (layoutId === 'shape-left-back-right') {
				if (x < 3.75) {
					return (app.viewer.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
				}
				const storage = app.component_configuration.productsComponents.find(x => x.type ===
					'storage' &&
					x.SKU ===
					'storage3x1CornerLeft');
				if (!storage) {
					throw STD.errors.user('No current storage found');
				}
				const boundingBoxStorage = storage.boundingBox;
				if (!boundingBoxStorage) {
					throw STD.errors.user('Missing bounding box for storage ');
				}
				return (app.viewer.mtx([ -decalage, 0, 1.5 ], [ 1, 1, 1 ], 270));
			} else {
				throw STD.errors.user('Unknown layoutId');
			}
		} else if (surface >= 25) {
			if (layoutId === 'shape-no-wall') {
				return (app.viewer.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
			} else if (layoutId === 'shape-back-left') {
				const storage = app.component_configuration.productsComponents.find(x => x.type ===
					'storage' &&
					x.SKU ===
					'storage2x1CornerRight');
				if (!storage) {
					throw STD.errors.user('No current storage found');
				}
				const boundingBoxStorage = storage.boundingBox;
				if (!boundingBoxStorage) {
					throw STD.errors.user('Missing bounding box for storage ');
				}
				return (app.viewer.mtx([ boundingBoxStorage.width + decalage, 0, 1 ], [ 1, 1, 1 ], 90));
			} else if (layoutId === 'shape-back') {
				const storage = app.component_configuration.productsComponents.find(x => x.type ===
					'storage' &&
					x.SKU ===
					'storage2x1Classic');
				if (!storage) {
					throw STD.errors.user('No current storage found');
				}
				const boundingBoxStorage = storage.boundingBox;
				if (!boundingBoxStorage) {
					throw STD.errors.user('Missing bounding box for storage ');
				}
				return (app.viewer.mtx([
					decalage + boundingBoxStorage.width,
					0,
					1
				], [ 1, 1, 1 ], 90));
			} else if (layoutId === 'shape-back-right') {
				const storage = app.component_configuration.productsComponents.find(x => x.type ===
					'storage' &&
					x.SKU ===
					'storage2x1CornerLeft');
				if (!storage) {
					throw STD.errors.user('No current storage found');
				}
				const boundingBoxStorage = storage.boundingBox;
				if (!boundingBoxStorage) {
					throw STD.errors.user('Missing bounding box for storage ');
				}
				return (app.viewer.mtx([ -decalage, 0, 1 ], [ 1, 1, 1 ], 270));
			} else if (layoutId === 'shape-left-back-right') {
				const storage = app.component_configuration.productsComponents.find(x => x.type ===
					'storage' &&
					x.SKU ===
					'storage2x1CornerLeft');
				if (!storage) {
					throw STD.errors.user('No current storage found');
				}
				const boundingBoxStorage = storage.boundingBox;
				if (!boundingBoxStorage) {
					throw STD.errors.user('Missing bounding box for storage ');
				}
				return (app.viewer.mtx([ -decalage, 0, 1 ], [ 1, 1, 1 ], 270));
			} else {
				throw STD.errors.user('Unknown layoutId');
			}
		} else {
			return (app.viewer.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
		}

	} else if (product.id === 'prestige') {
		const surface = x * z;
		if (surface >= 25) {
			if(layoutId === 'shape-no-wall'){
				return (app.viewer.mtx([ 0, 0, 1.5 ], [ 0, 0, 0 ], 90));
			}else if(layoutId === 'shape-back'){
				const storage = app.component_configuration.productsComponents.find(x => x.type ===
					'storage' &&
					x.SKU === 'storage3x1Classic');
				if (!storage) {
					throw STD.errors.user('No current storage found');
				}
				const boundingBoxStorage = storage.boundingBox;
				if (!boundingBoxStorage) {
					throw STD.errors.user('Missing bounding box for storage ');
				}
				return (app.viewer.mtx([ boundingBoxStorage.width, 0, 1.5 ], [ 1, 1, 1 ], 90));
			}else if(layoutId === 'shape-back-left'){
				const storage = app.component_configuration.productsComponents.find(x => x.type ===
					'storage' &&
					x.SKU === 'storage3x1CornerRight');
				if (!storage) {
					throw STD.errors.user('No current storage found');
				}
				const boundingBoxStorage = storage.boundingBox;
				if (!boundingBoxStorage) {
					throw STD.errors.user('Missing bounding box for storage ');
				}
				return (app.viewer.mtx([ boundingBoxStorage.width, 0, 1.5 ], [ 1, 1, 1 ], 90));
			}else if(layoutId === 'shape-back-right' || layoutId === 'shape-left-back-right'){
				return (app.viewer.mtx([ 0, 0, 1.5 ], [ 1, 1, 1 ], 270));
			}else{
				this.component_throwLibraryError('Unknown layout');
			}
		} else if (surface >= 18) {
			if(layoutId === 'shape-no-wall'){
				return (app.viewer.mtx([ 0, 0, 1 ], [ 0, 0, 0 ], 90));
			}else if(layoutId === 'shape-back'){
				const storage = app.component_configuration.productsComponents.find(x => x.type ===
					'storage' &&
					x.SKU === 'storage3x1Classic');
				if (!storage) {
					throw STD.errors.user('No current storage found');
				}
				const boundingBoxStorage = storage.boundingBox;
				if (!boundingBoxStorage) {
					throw STD.errors.user('Missing bounding box for storage ');
				}
				return (app.viewer.mtx([ boundingBoxStorage.width, 0, 1 ], [ 1, 1, 1 ], 90));
			}else if(layoutId === 'shape-back-left'){
				const storage = app.component_configuration.productsComponents.find(x => x.type ===
					'storage' &&
					x.SKU === 'storage3x1Classic');
				if (!storage) {
					throw STD.errors.user('No current storage found');
				}
				const boundingBoxStorage = storage.boundingBox;
				if (!boundingBoxStorage) {
					throw STD.errors.user('Missing bounding box for storage ');
				}
				return (app.viewer.mtx([ boundingBoxStorage.width, 0, 1 ], [ 1, 1, 1 ], 90));
			}else if(layoutId === 'shape-back-right' || layoutId === 'shape-left-back-right'){
				return (app.viewer.mtx([ 0, 0, 1 ], [ 1, 1, 1 ], 270));
			}else{
				this.component_throwLibraryError('Unknown layout');
			}
		} else {
			return (app.viewer.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
		}
	} else if (product.id === 'business') {
		const surface = x * z;
		const partitionsHeads = app.modules.used.find(x => x.id === 'standing-partitionsHeads');
		if (!partitionsHeads) {
			throw STD.errors.user('Partitions Heads not instanciate before storage');
		}
		const partitionHeadsComponent = <StandingPartitionsHeadsNS.Component> partitionsHeads.component;
		if (!partitionHeadsComponent) {
			throw STD.errors.user('Partitions Heads doesnt have component in storage');
		}
		const boundingBoxPartitionsHead = partitionHeadsComponent.isPartitionsHeads ?
			partitionHeadsComponent.partitionsWidth :
			0;
		if (!boundingBoxPartitionsHead && boundingBoxPartitionsHead !== 0) {
			throw STD.errors.user('Missing bounding box for partitionsHeads in storage');
		}
		if (surface >= 36) {
			if (layoutId === 'shape-no-wall') {
				return (app.viewer.mtx([ 0, 0, 0 ], [ 0, 0, 0 ], 0));
			} else if (layoutId === 'shape-back-left') {
				const storage = app.component_configuration.productsComponents.find(x => x.type ===
					'storage' &&
					x.SKU === 'storage3x1Classic');
				if (!storage) {
					throw STD.errors.user('No current storage found');
				}
				const boundingBoxStorage = storage.boundingBox;
				if (!boundingBoxStorage) {
					throw STD.errors.user('Missing bounding box for storage ');
				}
				return (app.viewer.mtx([ boundingBoxStorage.width, 0, 1.5 ], [ 1, 1, 1 ], 90));
			} else if (layoutId === 'shape-back') {
				const storage = app.component_configuration.productsComponents.find(x => x.type ===
					'storage' &&
					x.SKU ===
					'storage3x1Classic');
				if (!storage) {
					throw STD.errors.user('No current storage found');
				}
				const boundingBoxStorage = storage.boundingBox;
				if (!boundingBoxStorage) {
					throw STD.errors.user('Missing bounding box for storage ');
				}
				return (app.viewer.mtx([
					decalage + boundingBoxStorage.width,
					0,
					1.5
				], [ 1, 1, 1 ], 90));
			} else if (layoutId === 'shape-back-right') {
				const storage = app.component_configuration.productsComponents.find(x => x.type ===
					'storage' &&
					x.SKU ===
					'storage3x1CornerLeft');
				if (!storage) {
					throw STD.errors.user('No current storage found');
				}
				const boundingBoxStorage = storage.boundingBox;
				if (!boundingBoxStorage) {
					throw STD.errors.user('Missing bounding box for storage ');
				}
				return (app.viewer.mtx([ -decalage, 0, 1.5 ], [ 1, 1, 1 ], 270));
			} else if (layoutId === 'shape-left-back-right') {
				if (x < 3.75) {
					return (app.viewer.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
				}
				const storage = app.component_configuration.productsComponents.find(x => x.type ===
					'storage' &&
					x.SKU ===
					'storage3x1CornerLeft');
				if (!storage) {
					throw STD.errors.user('No current storage found');
				}
				const boundingBoxStorage = storage.boundingBox;
				if (!boundingBoxStorage) {
					throw STD.errors.user('Missing bounding box for storage ');
				}
				return (app.viewer.mtx([ -decalage, 0, 1.5 ], [ 1, 1, 1 ], 270));
			} else {
				throw STD.errors.user('Unknown layoutId');
			}
		} else if (surface > 25) {
			if (layoutId === 'shape-no-wall') {
				return (app.viewer.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0));
			} else if (layoutId === 'shape-back-left') {
				const storage = app.component_configuration.productsComponents.find(x => x.type ===
					'storage' &&
					x.SKU ===
					'storage2x1CornerRight');
				if (!storage) {
					throw STD.errors.user('No current storage found');
				}
				const boundingBoxStorage = storage.boundingBox;
				if (!boundingBoxStorage) {
					throw STD.errors.user('Missing bounding box for storage ');
				}
				return (app.viewer.mtx([ boundingBoxStorage.width + decalage, 0, 1 ], [ 1, 1, 1 ], 90));
			} else if (layoutId === 'shape-back') {
				const storage = app.component_configuration.productsComponents.find(x => x.type ===
					'storage' &&
					x.SKU ===
					'storage2x1Classic');
				if (!storage) {
					throw STD.errors.user('No current storage found');
				}
				const boundingBoxStorage = storage.boundingBox;
				if (!boundingBoxStorage) {
					throw STD.errors.user('Missing bounding box for storage ');
				}
				return (app.viewer.mtx([
					decalage + boundingBoxStorage.width,
					0,
					1
				], [ 1, 1, 1 ], 90));
			} else if (layoutId === 'shape-back-right') {
				const storage = app.component_configuration.productsComponents.find(x => x.type ===
					'storage' &&
					x.SKU ===
					'storage2x1CornerLeft');
				if (!storage) {
					throw STD.errors.user('No current storage found');
				}
				const boundingBoxStorage = storage.boundingBox;
				if (!boundingBoxStorage) {
					throw STD.errors.user('Missing bounding box for storage ');
				}
				return (app.viewer.mtx([ -decalage, 0, 1 ], [ 1, 1, 1 ], 270));
			} else if (layoutId === 'shape-left-back-right') {
				const storage = app.component_configuration.productsComponents.find(x => x.type ===
					'storage' &&
					x.SKU ===
					'storage2x1CornerLeft');
				if (!storage) {
					throw STD.errors.user('No current storage found');
				}
				const boundingBoxStorage = storage.boundingBox;
				if (!boundingBoxStorage) {
					throw STD.errors.user('Missing bounding box for storage ');
				}
				return (app.viewer.mtx([ -decalage, 0, 1 ], [ 1, 1, 1 ], 270));
			} else {
				throw STD.errors.user('Unknown layoutId');
			}
		} else {
			return (app.viewer.mtx([ 0, 0, 0 ], [ 0, 0, 0 ], 0));
		}

	} else {
		throw STD.errors.user('Unknown product name');
	}
};
